<template>
	<div>
		<div class="filter-inline-panel cle">
			<div class="list-opinion fr">
				<el-button type="primary" size="mini" v-if="hasBtn('add')" @click="add('')">{{$t('index.add')}}</el-button>
			</div>
		</div>
		<el-table :data="list" border size="mini">
			<el-table-column :prop="lang=='cn'?'title_cn':'title'" align="center" :label="$t('certificate.title')"></el-table-column>
			<el-table-column prop="code" align="center" :label="$t('certificate.code')"></el-table-column>
			<el-table-column prop="image" align="center" :label="$t('certificate.image')">
				<template slot-scope="scope">
		          <el-image style="width: 100px; height: 100px" v-if="scope.row.image" :src="scope.row.image" :preview-src-list="[scope.row.image]" fit="contain"></el-image>
		          <span v-if="!scope.row.image">{{$t('index.image_wu')}}</span>
		        </template>
			</el-table-column>
			<el-table-column prop="total" align="center" :label="$t('index.operation')">
				<template slot-scope="scope">
					<el-button type="primary" size="mini" v-if="hasBtn('edit')" @click="add(scope.row)">{{$t('index.edit')}}</el-button>
					<el-button type="info" size="mini" v-if="hasBtn('del')" @click="del(scope.row)">{{$t('index.del')}}</el-button>
				</template>
			</el-table-column>
		</el-table>
		<el-dialog :title="$t('index.dialog_title')" width="900px" :close-on-click-modal="false" :visible="editFormVisible" @close="editFormVisible = false">
			<el-form :model="editForm" size="mini" label-width="80px" label-position="top" :rules="editFormRules" ref="editForm">
				<el-row class="tree-content" :gutter="20">
					<el-col :span="12">
						<el-form-item :label="$t('index.cn')+$t('certificate.title')" prop="title_cn">
							<el-input v-model="editForm.title_cn" class="w100" :placeholder="$t('index.pleaseInput')" auto-complete="off"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item :label="$t('index.en')+$t('certificate.title')" prop="title">
							<el-input v-model="editForm.title" class="w100" :placeholder="$t('index.pleaseInput')" auto-complete="off"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
			            <el-form-item :label="$t('certificate.code')" prop="code">
			              <el-input v-model="editForm.code" :placeholder="$t('index.pleaseInput')" class="w100"></el-input>
			            </el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item :label="$t('certificate.image')" prop="image">
							<upload :value="editForm.image" name="certificate" @callback="function(res, file){imageSuccess(res, file,'image')}"></upload>
			              <!-- <el-upload class="avatar-uploader" :action="image_up+'uploadImg'" :data="{name:'certificate'}" :show-file-list="false" :on-success="function(res, file){imageSuccess(res, file,'image')} ">
			                <img v-if="editForm.image" :src="editForm.image" class="avatar">
			                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
			              </el-upload> -->
			            </el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button size="mini" @click.native="editFormVisible = false">{{$t('index.cancel')}}</el-button>
				<el-button size="mini" type="primary" @click.native="editSubmit('editForm')">{{$t('index.submit')}}</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
// import EditorBar from '../../components/wangEnduit.vue'
export default {
	components: {
		// EditorBar
	},
	data() {
		return {
			image_up: process.env.API_UP,
			editFormVisible: false,
			editForm: {},
			list: [],
			pages: {
				page: 1,
				count: 0,
				perpage: 10,
			},
			image:'',
			editFormRules: {

			}
		}
	},
	// 初始事件
	mounted: function () {
		this.init();
	},
	// 事件
	methods: {
		// 初始化
		init() {
			var this_ = this;
			var url = "certificateTmpList";
			var datas = {
			};
			this_.$post(url, datas).then((res) => {
				this_.list = res.list;
				this_.pages.count = res.sum;
			})
		},
		reset() {
			this.filters.type = '';
			this.init();
		},
		add(data) {
			var this_ = this;
			if (data) {
				this_.editForm = JSON.parse(JSON.stringify(data));
			} else {
				this_.editForm = {
					title: '',
					title_cn: '',
					code: '',
					image: '',
				}
			}
			this.editFormVisible = true;
		},
		// 保存
		editSubmit(editForm) {
			var this_ = this;
			this_.$refs.editForm.validate((valid) => {
				if (valid) {
					var datas = {
						title: this_.editForm.title,
						title_cn: this_.editForm.title_cn,
						code: this_.editForm.code,
					}
					if (this_.image) {
						datas['image']=this_.image;
					}
					var url = "certificateTmpAction";
					var tishi = this_.$t('index.add_success');
					if (this_.editForm.id) {
						datas['id'] = this_.editForm.id;
						tishi = this_.$t('index.modify_success');
					}
					this_.$post(url, datas).then((res) => {
						this_.$message.success(tishi);
						this_.editFormVisible = false;
						this_.init();
					});
				} else {
					return false;
				}
			})
		},
		del(data) {
			var this_ = this;
			var url = "certificateTmpDelete";
			var datas = {
				id: data.id
			};
			this_.$confirm(this_.$t('index.confirm_delete'), this_.$t('index.tips')).then(() => {
				this_.$post(url, datas).then((res) => {
					this_.$message.success(this_.$t('index.delete_success'));
					this_.init();
				})
			}).catch(() => {});
		},


		imageSuccess(res, file, name) {
			if (res.status == 200) {
				this.editForm[name] = res.data.showname;
				this.image = res.data.savename;
				this.$refs.editForm.clearValidate(name);
			} else {
				this.$message.success(res.message);
			}
		},
	},
	// 过滤器
	filters: {

	}
}
</script>
<style scoped>
.transaction_id {
	color: #ff0000;
}
</style>



// WEBPACK FOOTER //
// src/views/certificate/index.vue